/* src/components/Sidebar/FloatingTocSidebar.svelte generated by Svelte v3.48.0 */
import {
	SvelteComponent,
	append_hydration,
	attr,
	check_outros,
	children,
	claim_component,
	claim_element,
	claim_space,
	claim_text,
	create_component,
	destroy_component,
	detach,
	element,
	group_outros,
	init,
	insert_hydration,
	listen,
	mount_component,
	query_selector_all,
	safe_not_equal,
	set_data,
	space,
	src_url_equal,
	text,
	toggle_class,
	transition_in,
	transition_out
} from "svelte/internal";

import TableOfContentsInner from '../TableOfContents/TableOfContentsInner.svelte';

function create_if_block(ctx) {
	let nav;
	let tableofcontentsinner;
	let current;

	tableofcontentsinner = new TableOfContentsInner({
			props: {
				tree: /*tree*/ ctx[0],
				maxDepth: /*maxDepth*/ ctx[1]
			}
		});

	return {
		c() {
			nav = element("nav");
			create_component(tableofcontentsinner.$$.fragment);
			this.h();
		},
		l(nodes) {
			nav = claim_element(nodes, "NAV", { class: true });
			var nav_nodes = children(nav);
			claim_component(tableofcontentsinner.$$.fragment, nav_nodes);
			nav_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(nav, "class", "toc-root");
		},
		m(target, anchor) {
			insert_hydration(target, nav, anchor);
			mount_component(tableofcontentsinner, nav, null);
			current = true;
		},
		p(ctx, dirty) {
			const tableofcontentsinner_changes = {};
			if (dirty & /*tree*/ 1) tableofcontentsinner_changes.tree = /*tree*/ ctx[0];
			if (dirty & /*maxDepth*/ 2) tableofcontentsinner_changes.maxDepth = /*maxDepth*/ ctx[1];
			tableofcontentsinner.$set(tableofcontentsinner_changes);
		},
		i(local) {
			if (current) return;
			transition_in(tableofcontentsinner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(tableofcontentsinner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(nav);
			destroy_component(tableofcontentsinner);
		}
	};
}

function create_fragment(ctx) {
	let script;
	let script_src_value;
	let t0;
	let aside;
	let h4;
	let t1;
	let t2;
	let t3;
	let button;
	let t4;
	let t5;
	let current;
	let mounted;
	let dispose;
	let if_block = /*tree*/ ctx[0].length > 0 && create_if_block(ctx);

	return {
		c() {
			script = element("script");
			t0 = space();
			aside = element("aside");
			h4 = element("h4");
			t1 = text("Table of Contents");
			t2 = space();
			if (if_block) if_block.c();
			t3 = space();
			button = element("button");
			t4 = text("See ");
			t5 = text(/*expandText*/ ctx[3]);
			this.h();
		},
		l(nodes) {
			const head_nodes = query_selector_all('[data-svelte=\"svelte-1dd4l0p\"]', document.head);
			script = claim_element(head_nodes, "SCRIPT", { src: true });
			var script_nodes = children(script);
			script_nodes.forEach(detach);
			head_nodes.forEach(detach);
			t0 = claim_space(nodes);
			aside = claim_element(nodes, "ASIDE", { class: true });
			var aside_nodes = children(aside);
			h4 = claim_element(aside_nodes, "H4", { class: true });
			var h4_nodes = children(h4);
			t1 = claim_text(h4_nodes, "Table of Contents");
			h4_nodes.forEach(detach);
			t2 = claim_space(aside_nodes);
			if (if_block) if_block.l(aside_nodes);
			t3 = claim_space(aside_nodes);
			button = claim_element(aside_nodes, "BUTTON", { class: true });
			var button_nodes = children(button);
			t4 = claim_text(button_nodes, "See ");
			t5 = claim_text(button_nodes, /*expandText*/ ctx[3]);
			button_nodes.forEach(detach);
			aside_nodes.forEach(detach);
			this.h();
		},
		h() {
			script.defer = true;
			script.async = true;
			if (!src_url_equal(script.src, script_src_value = "/static/initToc.js")) attr(script, "src", script_src_value);
			attr(h4, "class", "toc-title");
			attr(button, "class", "floating-toc-toggler");
			attr(aside, "class", "floating-toc toc-root-wrap sticky");
			toggle_class(aside, "expand", /*expand*/ ctx[2]);
		},
		m(target, anchor) {
			append_hydration(document.head, script);
			insert_hydration(target, t0, anchor);
			insert_hydration(target, aside, anchor);
			append_hydration(aside, h4);
			append_hydration(h4, t1);
			append_hydration(aside, t2);
			if (if_block) if_block.m(aside, null);
			append_hydration(aside, t3);
			append_hydration(aside, button);
			append_hydration(button, t4);
			append_hydration(button, t5);
			current = true;

			if (!mounted) {
				dispose = listen(button, "click", /*toggleItem*/ ctx[4]);
				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (/*tree*/ ctx[0].length > 0) {
				if (if_block) {
					if_block.p(ctx, dirty);

					if (dirty & /*tree*/ 1) {
						transition_in(if_block, 1);
					}
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					transition_in(if_block, 1);
					if_block.m(aside, t3);
				}
			} else if (if_block) {
				group_outros();

				transition_out(if_block, 1, 1, () => {
					if_block = null;
				});

				check_outros();
			}

			if (!current || dirty & /*expandText*/ 8) set_data(t5, /*expandText*/ ctx[3]);

			if (dirty & /*expand*/ 4) {
				toggle_class(aside, "expand", /*expand*/ ctx[2]);
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			detach(script);
			if (detaching) detach(t0);
			if (detaching) detach(aside);
			if (if_block) if_block.d();
			mounted = false;
			dispose();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { tree, maxDepth } = $$props;
	let expand = false;
	let expandText = 'more';

	const toggleItem = () => {
		if (expand) {
			$$invalidate(2, expand = false);
			$$invalidate(3, expandText = 'more');
		} else {
			$$invalidate(2, expand = true);
			$$invalidate(3, expandText = 'Less');
		}
	};

	$$self.$$set = $$props => {
		if ('tree' in $$props) $$invalidate(0, tree = $$props.tree);
		if ('maxDepth' in $$props) $$invalidate(1, maxDepth = $$props.maxDepth);
	};

	return [tree, maxDepth, expand, expandText, toggleItem];
}

class FloatingTocSidebar extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { tree: 0, maxDepth: 1 });
	}
}

export default FloatingTocSidebar;